import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/role/ops")({
  beforeLoad: requirePermissionGuard("hca.dashboard.read_ops"),
});
